import React from "react";
import AddProductComponent from "../../components/admin/AddProductComponent";

const AddProducts = () => {
  return <AddProductComponent />;
};

export default AddProducts;
